import type { AppData, Period, Settings } from "@/types";
import { PERIOD_KEY } from "@/store/appTypes";
import { DEFAULT_CATEGORIES } from "@/utils/categories";

export const defaultSettings = (): Settings => ({
  logisticsFee: 12000,
  distribution: { donation: 2, advisor: 5, reinvestment: 13, management: 5 },
  titleStyle: { font: "Sora", color: "#FFFFFF", glow: true },
  walletBalances: { Bancolombia: 0, Daviplata: 0, Nequi: 0, "Caja Social": 0, Efectivo: 0 },
  logoUrl: "",
  kitItems: [],
  fundMovements: [],
  categories: [...DEFAULT_CATEGORIES],
  referralPvByMonth: {},
});

export const createEmptyData = (): AppData => {
  const now = new Date();
  return {
    products: [],
    distributors: [],
    clients: [],
    sales: [],
    inventory: [],
    advisorMovements: [],
    expenses: [],
    receivables: [],
    loans: [],
    promotions: [],
    encargos: [],
    restockItems: [],
    notifications: [],
    settings: defaultSettings(),
    importLogs: [],
    stockEntries: [],
    inventoryAdjustments: [],
    period: { year: now.getFullYear(), month: now.getMonth() },
    role: "admin",
  };
};

export const readPeriod = (): Period => {
  try {
    const raw = localStorage.getItem(PERIOD_KEY);
    if (raw) return JSON.parse(raw) as Period;
  } catch {
    /* ignore */
  }
  const now = new Date();
  return { year: now.getFullYear(), month: now.getMonth() };
};

export const mergeAdvisorStock = (
  base: Record<string, number>,
  extra: Record<string, number>
): Record<string, number> => {
  const out: Record<string, number> = { ...base };
  Object.entries(extra).forEach(([id, units]) => {
    out[id] = (out[id] ?? 0) + (units ?? 0);
  });
  return out;
};